import type { RootState } from 'state';

function getFlightRoutesTotalCount(state: RootState): number {
  const { value } = state.flightRoutes.routes;

  if (!value) {
    return 0;
  }

  return value.totalCount;
}

export default getFlightRoutesTotalCount;
